import { isDefined } from './helpers';
import Splide from '@splidejs/splide';

export function initRealisation() {
    sliderRealisation();
    ajaxRealisation();
}

function sliderRealisation()
{
    const slider = document.querySelector('.section-realisations-slider');

    if(!isDefined(slider)) return;

    let sliderRealisations = new Splide( slider, {
        type: "loop",
        speed : "1500",   
        interval : "3000",
        fixedHeight: 520,
        pagination:false,
        autoplay: false,
        waitForTransition: false,
        pauseOnHover: true,
        pauseOnFocus: false,
        updateOnMove: true,
        perPage: 3,
        gap: 14,
        mediaQuery: 'max',
        breakpoints: {
            1190: {
                perPage: 2,
                gap: 14,
            },
            800: 
            {
                autoplay: true,
                fixedHeight: 350,
                perPage: 1,
            }
        }
    });

    sliderRealisations.mount();
}

function ajaxRealisation()
{
    const loadMoreButton = document.getElementById('show-more-gallery');
    const galleryWrapper = document.querySelector('.gallery-wrapper');

    if(!isDefined(galleryWrapper)) return;

    const pageId = parseInt(galleryWrapper.dataset.id);
    
    loadMoreButton.addEventListener("click", function(e) {
        e.preventDefault();
        
        const max = galleryWrapper.dataset.max;
        const offset = galleryWrapper.dataset.offset;
        
        const formData = new FormData();
        formData.append( 'action', 'realisations' );
        formData.append( 'offset', offset );
        formData.append( 'max', max );
        formData.append( 'pageId', pageId );

        fetch("/wp-admin/admin-ajax.php", {
            method: "POST",
            credentials: 'same-origin',
            body: formData
        })
        .then((response) => response.json())
        .then((data) => {
            for(let i = 0; i < data['gallery'].length; i++)
            {
                galleryWrapper.appendChild(createRealisation(data['gallery'][i].url, data['gallery'][i].alt));
            }
            hideButtonMore(data['isLastRow']);
            changeRange();
            window.lightbox.reload();
        });
    });
}

function createRealisation(url, alt)
{
    let anchor = document.createElement('a');
    anchor.classList.add("gallery-item", "glightbox");
    anchor.href = url;

    let img = document.createElement('img');
    img.setAttribute('src', url);
    img.setAttribute('width', '445');
    img.setAttribute('height', '380');
    img.setAttribute('alt', alt);
    img.setAttribute('loading', 'lazy');

    anchor.appendChild(img);
    return anchor;
}

function changeRange()
{
    const galleryWrapper = document.querySelector('.gallery-wrapper');
    if(!isDefined(galleryWrapper)) return;
    galleryWrapper.dataset.offset = parseInt(galleryWrapper.dataset.max) + parseInt(galleryWrapper.dataset.offset);
}

function hideButtonMore(isLastRow)
{
    const loadMoreButton = document.getElementById('show-more-gallery');
    if(!isDefined(loadMoreButton)) return;
    if(isLastRow)
    {
        loadMoreButton.remove();
    }
}